<template>

	<div id="configurator-preview" >

		
		<p v-if="colorWarnings !='' ">{{colorWarnings}}</p>
		

		<img v-if="backgroundImage != null" :src="backgroundImage" style="z-index: 95" />
		<img v-if="apronImage != null" :src="apronImage" style="z-index: 98" />
		<img v-if="apronRibbonImage != null" :src="apronRibbonImage" style="z-index: 99" />
		<img v-if="skirtImage != null" :src="skirtImage" style="z-index: 96" />
		<img v-if="skirtRibbonImage != null" :src="skirtRibbonImage" style="z-index: 97" />
	</div>
</template>

<script>
	export default {
		name: 'ApronPreview',
		components: {
		},
		props: {
			configuredApron: Object,
			configuredSkirt: Object,
			colorWarnings: { type: String, default: '' }
		},
		data: function () {
			return {
			}
		},
		methods: {
			getMetallic: function (leadItem) {
				if (leadItem.fabricColorID == null) {
					return ''
				} else if (leadItem.fabricColor.metallic) {
					return 'Metallic'
				} else {
					return ''
				}
			},
		},
		computed: {
			rootFolder: function () {
				return '/images/apronImages/'
			},

			blnApronIncluded: function () {
				if (this.configuredApron == null) {
					return false
				}

				return this.configuredApron.includeInQuote

			},
			blnSkirtIncluded: function () {
				if (this.configuredSkirt == null) {
					return false
				}

				return this.configuredSkirt.includeInQuote

			},
			backgroundImage: function () {

				

				if (this.blnApronIncluded && this.blnSkirtIncluded) {
					//Both included
					return this.rootFolder + String(this.configuredApron.apronModelID) + '/apron/' + 'backgroundImage' + this.getMetallic(this.configuredApron) + '.png'
				}

				if (this.blnApronIncluded == false && this.blnSkirtIncluded == false) {
					//Both excluded
					return this.rootFolder + String(this.configuredApron.apronModelID) + '/apron/colorUndefined.png'
				}

				if (this.blnApronIncluded && this.blnSkirtIncluded == false) {
					//Apron (or vest) only

					if (this.configuredApron.model.manufacturerID != 1 || this.configuredApron.model.apronModelID == 101) {
						return this.rootFolder + 'NoImage.png'
					}

					if (this.configuredApron.model.setWith != -1) {
						//Part of a set
						return this.rootFolder + String(this.configuredApron.model.setWith) + '/apron/' + 'Excluded' + this.getMetallic(this.configuredApron) + '.png'
					} else {
						//Not part of a set
						return this.rootFolder + String(this.configuredApron.apronModelID) + '/apron/' + 'backgroundImage' + this.getMetallic(this.configuredApron) + '.png'
					}
				}

				if (this.blnApronIncluded == false && this.blnSkirtIncluded == true) {
					//Skirt only

					if (this.configuredSkirt.model.manufacturerID != 1) {
						return this.rootFolder + 'NoImage.png'
					}

					return this.rootFolder + String(this.configuredSkirt.model.setWith) + '/apron/' + 'Excluded' + this.getMetallic(this.configuredSkirt) + '.png'
				}

				return null

			},
			apronImage: function () {

				if (this.configuredApron == null) {
					return null
				}

				if (this.blnApronIncluded == false && this.configuredSkirt.includeInQuote == false) {
					return null
				}

				if (this.configuredApron.includeInQuote == false && (this.configuredSkirt != null && this.configuredSkirt.includeInQuote == true)) {
					return null //this.rootFolder + String(this.configuredApron.apronModelID) + '/apron/' + 'Excluded.png'
				} else if (this.configuredApron.includeInQuote == false && (this.configuredSkirt != null && this.configuredSkirt.includeInQuote == false)) {
					return this.rootFolder + String(this.configuredApron.apronModelID) + '/apron/' + 'Excluded.png'
				} else if (this.configuredApron.fabricColorID !== null && this.configuredApron.fabricColorID != 0) {
					return this.rootFolder + String(this.configuredApron.apronModelID) + '/apron/' + this.configuredApron.fabricColorID + '.png'
				} else {
					return null
				}

			},
			apronRibbonImage: function () {

				if (this.configuredApron == null) {
					return null
				}

				if (this.configuredApron.includeInQuote == false) {
					return null //this.rootFolder + String(this.configuredApron.apronModelID) + '/ribbon/' + ((this.configuredApron.fabricColor.metallic) ? 'ribbonMetallic/' : '') + 'Excluded.png'
				} else if (this.configuredApron.ribbonColorID !== null && this.configuredApron.ribbonColorID != 0) {
					return this.rootFolder + String(this.configuredApron.apronModelID) + '/ribbon/' + ((this.configuredApron.fabricColor.metallic) ? 'ribbonMetallic/' : '') + this.configuredApron.ribbonColorID + '.png'
				} else {
					return null
				}
			},
			skirtImage: function () {

				if (this.configuredSkirt == null) {
					return null
				}

				if (this.blnApronIncluded == false && this.configuredSkirt.includeInQuote == false) {
					return null
				}

				if (this.blnApronIncluded == true && this.configuredSkirt.includeInQuote == false) {
					return null
				} else if (this.configuredSkirt.includeInQuote == false) {
					return this.rootFolder + String(this.configuredSkirt.apronModelID) + '/apron/' + 'Excluded.png'
				} else if (this.configuredSkirt.fabricColorID !== null && this.configuredSkirt.fabricColorID != 0) {
					return this.rootFolder + String(this.configuredSkirt.apronModelID) + '/apron/' + this.configuredSkirt.fabricColorID + '.png'
				} else {
					return null
				}
			},
			skirtRibbonImage: function () {
				if (this.configuredSkirt == null) {
					return null
				}

				if (this.blnSkirtIncluded == false) {
					return null //this.rootFolder + String(this.configuredSkirt.apronModelID) + '/ribbon/' + 'Excluded.png'
				} else if (this.configuredSkirt.ribbonColorID !== null && this.configuredSkirt.ribbonColorID != 0) {
					return this.rootFolder + String(this.configuredSkirt.apronModelID) + '/ribbon/' + this.configuredSkirt.ribbonColorID + '.png'
				} else {
					return null
				}
			},
			

		},
		watch: {

		},
		mounted: function () {

		},
		updated: function () {

		}
	}
</script>
